(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-product-angle-toggle]');
    if (!toggle) return;

    var showSecond = !toggle.classList.contains('is-angle-2');
    toggle.classList.toggle('is-angle-2', showSecond);
    toggle.setAttribute('aria-pressed', showSecond ? 'true' : 'false');

    var productName = toggle.getAttribute('data-product-name') || 'product';
    toggle.setAttribute('aria-label', (showSecond ? 'Show first angle of ' : 'Show second angle of ') + productName);
  });
})();
